export enum PageCardEnum {
    ORDER_SETUP,
    RETEST_SETUP,
    ORDER_DETAILS,
}
